module.exports = __webpack_public_path__ + "static/5. Playing Field-ec5e183b7a469c6902274cd8656c3eb3.png";